import { render, staticRenderFns } from "./StripeResult.vue?vue&type=template&id=70008cfe&scoped=true"
import script from "./StripeResult.vue?vue&type=script&lang=js"
export * from "./StripeResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70008cfe",
  null
  
)

export default component.exports